import { render, staticRenderFns } from "./EstadoDeudaCombobox.vue?vue&type=template&id=1b084f30&scoped=true"
import script from "./EstadoDeudaCombobox.vue?vue&type=script&lang=js"
export * from "./EstadoDeudaCombobox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b084f30",
  null
  
)

export default component.exports